import React, { useEffect } from "react";
import { Form, Checkbox, Input, Col, Row, Typography, Layout, Card, Button } from "antd";
import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { Post } from "../../config/api/post";
import { QUERY } from "../../config/constants/api";
import { addUser, removeUser } from "../../redux/slice/authSlice";
import swal from "sweetalert";

//icons
import { IoMdPin } from "react-icons/io";
import { FaEnvelope, FaArrowLeft } from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FiMail, FiLock } from "react-icons/fi";


function ContactUs() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const [form] = Form.useForm();




    const onFinish = (values) => {
        console.log("Success:", values);
        setLoading(true);

        Post(QUERY.addQuery, values)
            .then((response) => {
                console.log("response", response)
                setLoading(false);
                if (response?.data?.status) {
                    swal("Success!", "Thankyou for your message. Our team will get back to you soon", "success");
                    form.resetFields()
                }
            })
            .catch((e) => {
                console.log(":::;", e);
                setLoading(false);
            });
    };

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

 useEffect(() => { window.scrollTo(0, 0); }, []);
    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Row
                className="blueBackground-old contactbnr"
                style={{
                    height: "45vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column"
                }}
            >
                <Typography.Title
                    className="fontFamily1 contactbnr-content"
                    style={{ fontSize: "30px", color: "#000", marginTop: 20, marginBottom: 0 }}
                >
                    {<> Checkout</>}
                </Typography.Title>
                <Typography.Text
                    className="fontFamily1 contactbnr-content"
                    style={{ fontSize: "18px", color: "#000", margin: 10 }}
                >
                    {<> Please let us know how we can improve your experience</>}
                </Typography.Text>
            </Row>



            {/* section 2 */}
            <Row
                className="whiteBackground"
                style={{ backgroundColor: "white", justifyContent: "center" }}
            >
                <Col xs={24} md={16}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",

                            padding: "50px 20px",
                        }}
                    >
                        <div style={{ marginBottom: 20, marginLeft: 10 }}>
                            <FaArrowLeft
                                style={{ marginRight: 8, fontSize: "20px", cursor: "pointer" }}
                                onClick={() => navigate(-1)}
                            />
                        </div>
                        <Card
                            className="contactCard1"
                            bordered={false}
                            style={{
                                width: "100%",
                                padding: "20px",
                            }}
                        >
                            <h3 className="fontFamily1"
                                style={{
                                    fontSize: "35px",
                                    fontWeight: 600,
                                    color: "black",
                                    textAlign: "left",
                                    paddingBottom:"14px",
                                    textAlign:"center",
                                }}>Shipping Information</h3>
                            <Form
                                layout="vertical"
                                name="basic"
                                form={form}
                                className="contactForm"
                                labelCol={{
                                    span: 0,
                                }}
                                wrapperCol={{
                                    span: 24,
                                }}
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                autoComplete="off"
                            >
                                <Row gutter={[16, 16]}>
                                    <Col lg={12}>
                                        <Form.Item
                                            label="Full Name*"
                                            name="name"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please input your full name!",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="large"
                                                placeholder="Enter Full Name"
                                                className="ContactFormInput"

                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Item
                                            label="Email*"
                                            name="email"
                                            rules={[
                                                {
                                                    type: "email",
                                                    message: "Please input valid email!",
                                                },
                                                {
                                                    required: true,
                                                    message: "Please input your email!",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="large"
                                                placeholder="Enter Email"
                                                className="ContactFormInput"

                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Item
                                            label="Address*"
                                            name="address"
                                            rules={[
                                                {
                                                    type: "text",
                                                    message: "Please input Address!",
                                                },
                                                {
                                                    required: true,
                                                    message: "Please input Address!",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="large"
                                                placeholder="Enter Address"
                                                className="ContactFormInput"

                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Item
                                            label="Country*"
                                            name="country"
                                            rules={[
                                                {
                                                    type: "Country",
                                                    message: "Please input Country!",
                                                },
                                                {
                                                    required: true,
                                                    message: "Please input your Country!",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="large"
                                                placeholder="Enter Country"
                                                className="ContactFormInput"

                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col lg={8}>
                                        <Form.Item
                                            label="City*"
                                            name="city"
                                            rules={[
                                                {
                                                    type: "City",
                                                    message: "Please input City!",
                                                },
                                                {
                                                    required: true,
                                                    message: "Please input your City!",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="large"
                                                placeholder="Enter City"
                                                className="ContactFormInput"

                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col lg={8}>
                                        <Form.Item
                                            label="State*"
                                            name="state"
                                            rules={[
                                                {
                                                    type: "State",
                                                    message: "Please input State!",
                                                },
                                                {
                                                    required: true,
                                                    message: "Please input your State!",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="large"
                                                placeholder="Enter State"
                                                className="ContactFormInput"

                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col lg={8}>
                                        <Form.Item
                                            label="Zip*"
                                            name="zip"
                                            rules={[
                                                {
                                                    type: "zip",
                                                    message: "Please input zip!",
                                                },
                                                {
                                                    required: true,
                                                    message: "Please input your zip!",
                                                },
                                            ]}
                                        >
                                            <Input
                                                size="large"
                                                placeholder="Enter Zip Code"
                                                className="ContactFormInput"

                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>















                                {/* <Form.Item
                                    label="Subject*"
                                    name="subject"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your subject",
                                        },
                                    ]}
                                >
                                    <Input
                                        size="large"
                                        placeholder="Enter Subject"
                                        className="ContactFormInput"

                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Message*"
                                    name="message"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input your message",
                                        },
                                    ]}
                                >
                                    <Input.TextArea
                                        size="large"
                                        placeholder="Enter Message"
                                        className="ContactFormTextField"
                                        rows={4}

                                    />
                                </Form.Item> */}



                                <br />

                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="loginButton"
                                    >
                                        {loading ? "Loading..." : "Continue to checkout"}
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </div>
                </Col>

                {/* <Col xs={24} md={6}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",

                            padding: "50px 20px",
                        }}
                    >
                        <Card
                            className="contactCard2"
                            bordered={false}

                        >
                            <Row style={{
                                width: "100%",
                                padding: "20px",
                                display: 'flex',
                                flexDirection: "column",
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <Typography.Title
                                    className="fontFamily1"
                                    style={{
                                        fontSize: "24px",
                                        fontWeight: 600,
                                        color: "black",
                                        textAlign: "center",
                                        marginTop: 0,
                                    }}
                                >
                                    {
                                        <>
                                            Get in touch with us
                                        </>
                                    }
                                </Typography.Title>
                                <Typography.Text
                                    className="fontFamily1"
                                    style={{ fontSize: "14px", color: "grey", textAlign: "center", justifyContent: "center" }}
                                >
                                    Let us know what you want to know. We want to help people learn, grow and achieve more in life.
                                </Typography.Text>

                                <Button
                                    type="primary"
                                    shape="circle"
                                    style={{
                                        backgroundColor: "#86D6E0",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "50px",
                                        height: "50px",
                                        marginTop: "30px"
                                    }}
                                    icon={
                                        <IoMdPin
                                            style={{ color: "white", fontSize: "20px" }}
                                        />
                                    }
                                />
                                <Typography.Text
                                    className="fontFamily1"
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "black",
                                        textAlign: "center",
                                        marginTop: 10,
                                    }}
                                >
                                    {
                                        <>
                                            1000 Front Street #147 Uniondale, NY 11553
                                        </>
                                    }
                                </Typography.Text>

                                <Button
                                    type="primary"
                                    shape="circle"
                                    style={{
                                        backgroundColor: "#86D6E0",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "50px",
                                        height: "50px",
                                        marginTop: "30px"
                                    }}
                                    icon={
                                        <FaEnvelope
                                            style={{ color: "white", fontSize: "20px" }}
                                        />
                                    }
                                />
                                <Typography.Text
                                    className="fontFamily1"
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "black",
                                        textAlign: "center",
                                        marginTop: 10,
                                    }}
                                >
                                    {
                                        <>
                                            info@wrightco.com
                                        </>
                                    }
                                </Typography.Text>

                                <Button
                                    type="primary"
                                    shape="circle"
                                    style={{
                                        backgroundColor: "#86D6E0",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "50px",
                                        height: "50px",
                                        marginTop: "30px"
                                    }}
                                    icon={
                                        <BsFillTelephoneFill
                                            style={{ color: "white", fontSize: "20px" }}
                                        />
                                    }
                                />
                                <Typography.Text
                                    className="fontFamily1"
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "black",
                                        textAlign: "center",
                                        marginTop: 10,
                                    }}
                                >
                                    {
                                        <>
                                            877-701-2899
                                        </>
                                    }
                                </Typography.Text>
                            </Row>
                            <br />
                            <br />

                        </Card>
                    </div>
                </Col> */}
            </Row>
        </Layout>
    );
}

export default ContactUs;
